export const MEMBER_TYPES = {
  AGENT: 'Agent',
  CONJOINT: 'Conjoint',
  CONJOINTE: 'Conjointe',
  ENFANT: 'Enfant'
};

export const ORIENT_SERVICE = {
  MEDICAL: 'MEDICAL',
  DENTAL: 'DENTAL',
  NURSING: 'NURSING'
};

export const ORIENT_LABELS = {
  [ORIENT_SERVICE.MEDICAL]: 'Médecine générale',
  [ORIENT_SERVICE.DENTAL]: 'Dentiste',
  [ORIENT_SERVICE.NURSING]: 'Infirmerie'
};

export const ORIENT_LABELS_SHORT = {
  [ORIENT_SERVICE.MEDICAL]: 'Médical',
  [ORIENT_SERVICE.DENTAL]: 'Dentaire',
  [ORIENT_SERVICE.NURSING]: 'Infirmerie'
};
